import { authorizedRequest } from "~/src/utils/axios";
import {
  type UpdateNickNameOfFriendRequest,
  type CreateNickNameOfFriendRequest,
} from "~/src/models/secure-chat";
import { API_ENDPOINT } from "../endpoint";

export const nicknameApi = {
  createNickName: async (
    params: CreateNickNameOfFriendRequest
  ): Promise<any> => {
    const { friendId, name } = params;
    return await authorizedRequest.post(`${API_ENDPOINT.NICKNAME}`, {
      name,
      friend_id: friendId,
    });
  },

  updateNickName: async (
    params: UpdateNickNameOfFriendRequest
  ): Promise<any> => {
    const { name, nickNameId } = params;
    return await authorizedRequest.patch(
      `${API_ENDPOINT.NICKNAME}/${nickNameId}`,
      {
        name,
      }
    );
  },

  deleteNickName: async (nickNameId: string): Promise<any> => {
    return await authorizedRequest.delete(
      `${API_ENDPOINT.NICKNAME}/${nickNameId}`
    );
  },

  getNickNames: async (page: number, signal?: AbortSignal): Promise<any> =>
    await authorizedRequest.get(`${API_ENDPOINT.USER}/nicknames?page=${page}`, {
      signal,
    }),
};
